import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { Flex } from 'components/shared/flex'
import { TableCell } from 'components/shared/widget'
import { HomeProduct } from 'entities/home_product'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'
import { SampleViewModel } from 'view_models/sample_view_model'

export const homeProductColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'home_product_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '作成日', th: true, width: 120, form: form, orderAttr: 'home_product_created_at', searchType: { name: 'created_at', type: 'date' } },
            { name: '商品コード', th: true, width: 120, form: form, orderAttr: 'home_product_code', searchType: { name: 'code', type: 'text' } },
            { name: '商品名', th: true, minWidth: 200, form: form, orderAttr: 'home_product_name', searchType: { name: 'name', type: 'text' } },
            {
                name: '価格(税抜)',
                th: true,
                width: 120,
                align: 'right',
                form: form,
                orderAttr: 'home_product_price',
                searchType: { name: 'price', type: 'number' },
            },
            { name: '紐付いている製品', th: true, width: 500 },
        ],
    }
}

export type HomeProductTableDataProps = {
    homeProduct?: HomeProduct
    displaySetting: DisplaySetting
}

export const HomeProductTableData = ({ homeProduct, displaySetting }: HomeProductTableDataProps): JSX.Element => {
    if (!homeProduct) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        const sampleVm = new SampleViewModel({ productItems: homeProduct.productItems })
        return (
            <>
                <TableCell>{homeProduct.id}</TableCell>
                <TableCell>{toDateText(homeProduct.createdAt)}</TableCell>
                <TableCell>
                    <div>{homeProduct.code}</div>
                </TableCell>
                <TableCell>
                    <Flex alignItems="center">
                        <div style={{ backgroundColor: homeProduct.color, width: 10, height: 10 }}></div>
                        <div>{homeProduct.name}</div>
                    </Flex>
                </TableCell>
                <TableCell align="right">{homeProduct.price?.toLocaleString()}</TableCell>
                <TableCell>{sampleVm.productItemView()}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
